import { Grid2, Stack, Typography } from "@mui/material";
import { relationshipEnumMap } from "../enum/formEnum";

const AuthorizedContactDetail = ({ formData, fromReview=false }) => {

  const contactLabels = {
    contactFirstName: "First Name",
    contactLastName: "Last Name",
    contactRelationship: "Relationship",
    contactRoles: "Contact Roles",
    contactPhoneNumber: "Phone Number",
    contactEmail: "Contact Email",
    facilityAddress: "Address",
    city: "City",
    state: "State",
    zipCode: "ZIP Code"
  };
  const contactRolesEnumMap = {
    primary: "Primary Contact",
    emergency: "Emergency Contact",
    medical: "Medical Power of Attorney",
  };
  const capitalizeFirst = (str) =>
    typeof str === "string" && str.length > 0
      ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
      : str;
  return (
    <>
      <Typography variant="h4" color="default.main">
        Authorized Contacts
      </Typography>
      {formData?.contacts?.map((contact, contactIndex) => (
        <Stack key={contactIndex} mt={3}>
          <Typography variant="h5" color="default.main">
            {`Contacts ${contactIndex + 1}`}
          </Typography>
          <Grid2 container spacing={3} mt={2} >
            {Object.entries(contactLabels).map(([key, label]) => {
              const value = contact[key];

              if (key === "contactRoles" && value) {
                return (
                  <Grid2 size={{ xs: 12, sm: 4 }} key={key}>
                    <Typography variant="body2" color="default.main" mb={0.5}>
                      {label}
                    </Typography>
                    <Typography variant="body1" color="default.light">

                      {value.map(
                        (role) =>
                          contactRolesEnumMap[role] || capitalizeFirst(role)
                      )
                        .join(", ")}{" "}
                      {/* Join array elements into a string */}
                    </Typography>
                  </Grid2>
                );
              }

              return (
                value &&
                <Grid2 size={{ xs: 12, sm: 4 }} key={key}>
                  <Typography variant="body2" color="default.main" mb={0.5}>
                    {label}
                  </Typography>
                  <Typography variant="body1" color="default.light">
                    {label === "Relationship" ? relationshipEnumMap[value] : value || "N/A"}
                  </Typography>
                </Grid2>
              );
            })}
          </Grid2>
        </Stack>
      ))}
    </>
  );
};
export default AuthorizedContactDetail;